import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77d6e0ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-root" }
const _hoisted_2 = { class: "d-flex flex-column flex-xl-row flex-column-fluid" }
const _hoisted_3 = { class: "d-flex flex-column flex-lg-row-fluid" }
const _hoisted_4 = { class: "d-flex flex-row-fluid flex-center p-10" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "svg/logos/logo-devfactory.svg",
  class: "h-60px"
}, null, -1))
const _hoisted_7 = { class: "text-dark fs-2x mb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-200px min-h-xl-450px mb-xl-10",
  style: {"background-image":"url('svg/authentication/member-registre-icon.svg')"}
}, null, -1))
const _hoisted_9 = { class: "flex-row-fluid d-flex flex-center justfiy-content-xl-first p-10" }
const _hoisted_10 = { class: "d-flex flex-center bg-body rounded w-100 w-md-700px mx-auto" }
const _hoisted_11 = { class: "modal-body py-10" }
const _hoisted_12 = { class: "notice d-flex mb-10 p-6" }
const _hoisted_13 = { class: "d-flex flex-center flex-grow-1" }
const _hoisted_14 = { class: "fw-bold" }
const _hoisted_15 = { class: "text-gray-800 fw-bolder text-center" }
const _hoisted_16 = {
  type: "button",
  class: "btn btn-light-primary fw-bolder w-100 mb-10"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "svg/authentication/google-icon.svg",
  class: "h-20px me-3"
}, null, -1))
const _hoisted_18 = { class: "d-flex align-items-center mb-5" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-gray-300 mw-50 w-100" }, null, -1))
const _hoisted_20 = { class: "fw-bold text-gray-400 fs-7 mx-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-bottom border-gray-300 mw-50 w-100" }, null, -1))
const _hoisted_22 = { class: "row g-9 mb-8" }
const _hoisted_23 = { class: "col-md-6 fv-row" }
const _hoisted_24 = { class: "required form-label" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "col-md-6 fv-row" }
const _hoisted_28 = { class: "required form-label" }
const _hoisted_29 = { class: "fv-plugins-message-container" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "row g-9 mb-8" }
const _hoisted_32 = { class: "col-md-6 fv-row" }
const _hoisted_33 = { class: "required form-label" }
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "col-md-6 fv-row" }
const _hoisted_37 = { class: "required form-label" }
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = { class: "d-flex flex-column mb-6 fv-row" }
const _hoisted_41 = { class: "required form-label" }
const _hoisted_42 = { value: "Full Stack" }
const _hoisted_43 = { value: "Expert Referencing" }
const _hoisted_44 = { value: "Full Stack" }
const _hoisted_45 = { class: "fv-plugins-message-container" }
const _hoisted_46 = { class: "fv-help-block" }
const _hoisted_47 = { class: "d-flex flex-column mb-8 fv-row" }
const _hoisted_48 = { class: "d-flex align-items-center form-label" }
const _hoisted_49 = { class: "required" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify a target priorty"
}, null, -1))
const _hoisted_51 = { class: "modal-footer flex-center" }
const _hoisted_52 = {
  type: "reset",
  id: "kt_modal_create_api_key_cancel",
  class: "btn btn-white me-3"
}
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "indicator-label" }
const _hoisted_55 = { class: "indicator-progress" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t("welcomeTo")) + " DevFactory ", 1)
          ])
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Form, {
            class: "form w-100",
            onSubmit: _ctx.submit,
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("h1", _hoisted_15, _toDisplayString(_ctx.$t("userInfo")), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("button", _hoisted_16, [
                    _hoisted_17,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("signIn")) + " " + _toDisplayString(_ctx.$t("with")) + " Google ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("or")), 1),
                    _hoisted_21
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("firstName")), 1),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid",
                        placeholder: "Your First Name",
                        name: "firstName",
                        modelValue: _ctx.userForm.firstName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userForm.firstName) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_ErrorMessage, { name: "firstName" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("lastName")), 1),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control form-control-solid",
                        placeholder: "Your Last Name",
                        name: "lastName",
                        modelValue: _ctx.userForm.lastName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userForm.lastName) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createVNode(_component_ErrorMessage, { name: "lastName" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("password")), 1),
                      _createVNode(_component_Field, {
                        type: "password",
                        class: "form-control form-control-solid",
                        rows: "3",
                        name: "password",
                        placeholder: "password",
                        modelValue: _ctx.userForm.password,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userForm.password) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                          _createVNode(_component_ErrorMessage, { name: "password" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t("confirmPassword")), 1),
                      _createVNode(_component_Field, {
                        type: "password",
                        class: "form-control form-control-solid",
                        rows: "3",
                        name: "cpassword",
                        placeholder: "Password Confirmation",
                        modelValue: _ctx.userForm.cpassword,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userForm.cpassword) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createVNode(_component_ErrorMessage, { name: "cpassword" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("selectTitle")), 1),
                    _createVNode(_component_Field, {
                      name: "title",
                      "data-control": "select2",
                      "data-hide-search": "true",
                      "data-placeholder": "Select a Category...",
                      class: "form-select form-select-solid",
                      as: "select",
                      modelValue: _ctx.userForm.title,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userForm.title) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_42, _toDisplayString(_ctx.$t("Web Developer")), 1),
                        _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.$t("expertSeo")), 1),
                        _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.$t("fullStack")), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_ErrorMessage, { name: "title" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("label", _hoisted_48, [
                      _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t("skills")), 1),
                      _hoisted_50
                    ]),
                    _createVNode(_component_el_form_item, { prop: "skills" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.userForm.skills,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userForm.skills) = $event)),
                          multiple: "",
                          filterable: "",
                          "allow-create": "",
                          "default-first-option": "",
                          placeholder: "Choose skills for your Competence",
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "java",
                              value: "java"
                            }),
                            _createVNode(_component_el_option, {
                              label: "javascript",
                              value: "javascript"
                            }),
                            _createVNode(_component_el_option, {
                              label: "react js ",
                              value: "react js"
                            }),
                            _createVNode(_component_el_option, {
                              label: "go",
                              value: "go"
                            }),
                            _createVNode(_component_el_option, {
                              label: "docker",
                              value: "docker"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("button", _hoisted_52, _toDisplayString(_ctx.$t("discard")), 1),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary",
                  disabled: 
                  !_ctx.userForm.firstName ||
                  !_ctx.userForm.cpassword ||
                  !_ctx.userForm.password ||
                  !_ctx.userForm.skills ||
                  !_ctx.userForm.title ||
                  !_ctx.userForm.lastName
                ,
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, [
                  _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t("submit")), 1),
                  _createElementVNode("span", _hoisted_55, [
                    _createTextVNode(_toDisplayString(_ctx.$t("pleaseWait")) + "... ", 1),
                    _hoisted_56
                  ])
                ], 8, _hoisted_53)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ]))
}